import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';
import { CloudApiService } from './services/cloud-api.service';

export const authGuard: CanActivateFn = async (route, state) => {
    const cloud = inject(CloudApiService);
    const router = inject(Router);

    // On a cold load the access token is minted from the refresh cookie — wait for that
    // round-trip, otherwise a deep link would bounce to the login page.
    await cloud.sessionReady;

    if (cloud.isAuthenticated()) {
        if (!environment.production) {
            console.log('Authenticated, allowing access to', state.url);
        }
        return true;
    }
    if (!environment.production) {
        console.log('Not authenticated, redirecting to login');
    }
    return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: state.url } });
};
